import { createSelector } from '@ngrx/store';
import { createUserContext, UserContext } from '@iss/libs/user-context';

import { appContextFeature } from './app-context';

export const selectUserContext = createSelector(
  appContextFeature.selectRole,
  appContextFeature.selectCountry,
  appContextFeature.selectSupplier,
  appContextFeature.selectCustomer,
  appContextFeature.selectSite,
  appContextFeature.selectServiceLocation,
  (role, country, supplier, customer, site, serviceLocation): UserContext | null =>
    createUserContext({
      role,
      country,
      customer,
      site,
      serviceLocation,
      supplier,
    }),
);
